import { createContext } from 'react';
import { GetAccountsPositionsHistoryParams } from '@goldwasserexchange/actor/rest-services';

export const accountsPositionsHistoryParamsContext = createContext<Partial<GetAccountsPositionsHistoryParams>>({});
